import _ from 'lodash';

export const isValidEmail = (email) => {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(email);
};

export const upperCaseFirstLetterManyWords = (str) => {
  return str
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const getErrorMessage = (error) => {
  if (error?.error_detail) return error.error_detail;
  if (error?.error_message) return error.error_message;
  return false;
};
export function debounce(func, delay) {
  let timerId;

  return function (...args) {
    if (timerId) {
      clearTimeout(timerId);
    }

    timerId = setTimeout(() => {
      func.apply(this, args);
      timerId = null;
    }, delay);
  };
}

export function convertToTitleCase(str) {
  return str
    .split('-')
    .map((word) => _.startCase(word))
    .join('-');
}

export function convertTrailingZero(value) {
  return parseFloat(value) || 0;
}

export function isBoundsInside(bounds1, bounds2) {
  return (
    bounds2._sw.lng > bounds1._sw.lng &&
    bounds2._sw.lat > bounds1._sw.lat &&
    bounds2._ne.lng < bounds1._ne.lng &&
    bounds2._ne.lat < bounds1._ne.lat
  );
}
export function mergeBounds(bounds1, bounds2) {
  const mergedBounds = {
    _sw: {
      lng: Math.min(bounds1._sw.lng, bounds2._sw.lng),
      lat: Math.min(bounds1._sw.lat, bounds2._sw.lat),
    },
    _ne: {
      lng: Math.max(bounds1._ne.lng, bounds2._ne.lng),
      lat: Math.max(bounds1._ne.lat, bounds2._ne.lat),
    },
  };
  return mergedBounds;
}

export const toFixedNoZero = (num, fixed) => {
  if (!num) {
    return 0;
  }
  return num.toFixed(fixed).replace(/\.?0+$/, '');
};

export const translateFirebaseError = (error = '') => {
  if (!error.includes('Firebase')) return error;
  let tmpError = error;
  if (tmpError.includes('Hostname match not found')) {
    return 'Your domain is not in authentication list as you can not login with this phone number.';
  }
  if (tmpError.includes('invalid-verification-code')) {
    return 'Invalid verification code';
  }

  return error;
};

export const validateUploadFile = (
  file,
  maxFileSize = 5000000,
  validFileTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'],
) => {
  if (!file) {
    return 'File is missing';
  }

  const isValidFileType = validFileTypes.includes(file.type);

  if (!isValidFileType) {
    return 'Invalid file type';
  }

  if (file.size > maxFileSize) {
    return 'File size is greater than 5MB';
  }

  return '';
};
